import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../context/LanguageContext';
import { useGuest } from '../context/GuestContext';
import '../styles/InfoSection.css';

const BRIDE_GROOM_CARDS = {
  amiker: [
    { title: 'Your Checklist', text: "Dress? Check. Flowers? Check. Groom? ...He'll show up." },
    { title: 'Day-Of Survival Kit', text: "Snacks (mandatory), tissues, backup mascara, and someone to keep you calm." },
    { title: 'Remember', text: "This is YOUR day. If anyone asks about seating, pretend you didn't hear them." },
  ],
  gergely: [
    { title: 'Your Checklist', text: "Suit? Check. Ring? CHECK THE RING. Speech? ...Wing it." },
    { title: 'Day-Of Survival Kit', text: "A good breakfast, comfortable shoes, and the emotional capacity to cry in public." },
    { title: 'Remember', text: "Whatever she says, the answer is yes. You've been practising this for years." },
  ],
};

const InfoSection = () => {
  const { t } = useTranslation();
  const { guest } = useGuest();

  const personalCards = guest?.special && BRIDE_GROOM_CARDS[guest.special];

  const cards = [
    { key: 'guestPolicy', icon: '~' },
    { key: 'whatNow', icon: '~' },
    { key: 'children', icon: '~' },
    { key: 'contact', icon: '~' },
  ];

  return (
    <section id="info-section" className="info-section">
      <motion.div
        className="info-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="info-title">
          {guest?.special === 'amiker'
            ? "Bride's Briefing"
            : guest?.special === 'gergely'
            ? "Groom's Guide"
            : t('info.title')}
        </h2>
      </motion.div>

      <div className="info-cards">
        {personalCards
          ? personalCards.map((card, i) => (
              <motion.div
                key={card.title}
                className="info-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
              >
                <div className="info-card-accent" />
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </motion.div>
            ))
          : cards.map((card, i) => (
              <motion.div
                key={card.key}
                className="info-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
              >
                <div className="info-card-accent" />
                <h3>{t(`info.${card.key}Title`)}</h3>
                <p>
                  {t(`info.${card.key}Text`)}
                  {card.key === 'contact' && (
                    <>
                      {' '}
                      <a href={`mailto:${t('info.contactEmail')}`} className="info-email-link">
                        {t('info.contactEmail')}
                      </a>
                    </>
                  )}
                </p>
              </motion.div>
            ))}
      </div>
    </section>
  );
};

export default InfoSection;
